const updateProductGallery = (variant) => {
  const firstImageContainers = document.querySelectorAll('[data-first-image-container]');
  if (!firstImageContainers.length) return;

  // Only update if variant has a featured_image
  if (!variant || !variant.featured_image || !variant.featured_image.src) return;

  const getImageSrc = (src) => {
    if (!src) return src;
    if (src.startsWith('//')) return window.location.protocol + src;
    if (src.startsWith('/')) return window.location.origin + src;
    return src;
  };

  const imageURL = variant.featured_image.src;
  const formattedImageURL = getImageSrc(imageURL);

  firstImageContainers.forEach((container) => {
    const imageEls = container.querySelectorAll('img');
    if (!imageEls.length) return;

    const currentSrc = imageEls[0].getAttribute('src');
    if (currentSrc === formattedImageURL) return;

    imageEls.forEach((imageEl) => {
      imageEl.setAttribute('src', formattedImageURL);
      if (imageEl.hasAttribute('srcset')) imageEl.setAttribute('srcset', formattedImageURL);
      if (variant.featured_image?.alt) imageEl.setAttribute('alt', variant.featured_image.alt);
    });

    // Keep the lightbox in sync so opening it after a variant switch shows the new image.
    container.dataset.lightboxImage = formattedImageURL;
    if (variant.featured_image.width) container.dataset.lightboxWidth = variant.featured_image.width;
    if (variant.featured_image.height) container.dataset.lightboxHeight = variant.featured_image.height;

    // On mobile the gallery is a Swiper carousel, so the new first image can be
    // scrolled out of view — jump back to it so the variant switch is visible.
    // `.swiper` is only present while the mobile carousel is active (it's cleared
    // on destroy at the desktop breakpoint), so this is a no-op on desktop.
    const swiperInstance = container.closest('[data-swiper-mob]')?.swiper;
    if (swiperInstance) swiperInstance.slideToLoop(0);
  });
};

export default updateProductGallery;